module.exports = __webpack_public_path__ + "img/cone-striped.f489c087.svg";